enum ROUTES {
  ACCOUNTS = '/accounts',
  ACCOUNTS_LIST = '/accounts/list',
  ACCOUNTS_CREATE = '/accounts/list/create',
  ACCOUNTS_EDIT = '/accounts/list/:accountId',
  CHARTS_OF_ACCOUNTS = '/accounts/charts',
  CATEGORIES = '/accounts/charts/:categoryId',
  GROUPS = '/accounts/charts/:categoryId/:groupId',
  PRIMARY_ACCOUNTS = '/accounts/charts/:categoryId/:groupId/:primaryAccountId',
  GROUP_ADD = '/accounts/charts/:categoryId/:groupId/:primaryAccountId/add-group',
  GROUP_EDIT = '/accounts/charts/:categoryId/:groupId/:primaryAccountId/edit-group',
  CATEGORY_ADD = '/accounts/charts/:categoryId/:groupId/:primaryAccountId/add-category',
  CATEGORY_EDIT = '/accounts/charts/:categoryId/:groupId/:primaryAccountId/edit-category',
  PRIMARY_ACCOUNT_ADD = '/accounts/charts/:categoryId/:groupId/:primaryAccountId/add-account',
  PRIMARY_ACCOUNT_EDIT = '/accounts/charts/:categoryId/:groupId/:primaryAccountId/edit-account',
  STATEMENTS_OF_ACCOUNTS = '/accounts/statements',
  EXTERNAL_ACCOUNTS = '/accounts/external',
  EXTERNAL_ACCOUNTS_LIST = '/accounts/external/accounts-list',
  EXTERNAL_ACCOUNTS_LIST_CREATE = '/accounts/external/accounts-list/create',
  EXTERNAL_ACCOUNT = '/accounts/external/accounts-list/:accountId',
  EXTERNAL_ACCOUNTS_LINKED_CLIENTS = '/accounts/external/linked-clients',
  EXTERNAL_ACCOUNTS_LINKED_CLIENTS_CREATE = '/accounts/external/linked-clients/create',
  TRANSACTIONS_GL = '/accounts/statements/:transactionId/gl',
}

export default ROUTES;
